// extracted by mini-css-extract-plugin
export default {"button":"styles_button__1YYPp","icon":"styles_icon__sLr3I"};